// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"57653855","828":"62426075"}[chunkId] + ".chunk.js";
};